import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  BoundaryTerritoryCreateContainer, type BoundaryTerritoryCreateContainerProps,
} from './boundaryTerritoryCreate.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    BoundaryTerritoryCreate: BoundaryTerritoryCreateContainerProps;
  }
}
modalRenderer.register('BoundaryTerritoryCreate', BoundaryTerritoryCreateContainer);
